<div
  #inputMentionWrapper
  data-cy="input-mention-wrapper"
  [attr.role]="type"
  [id]="tagifyId"
  [ngClass]="{ 'input-mention-wrapper': true, hasIcon: sendIcon ? true : false }">
  <ng-content [select]="title" />
  <tagify [name]="tagifyId" [readonly]="readonly" [settings]="tagifyOptions" [whitelist]="tags">
    <ng-container #tagsVcr />
  </tagify>
  <div class="input-mention-icons">
    <ng-content select="[icons]" />
    @if (sendIcon) {
      <i
        aria-hidden="true"
        class="icon-send"
        data-cy="input-mention-send-button"
        role="button"
        (click)="enterEmitter.emit($event)"></i>
    }
  </div>
</div>
<ng-container #tagsListVcr />
